import { useState } from 'react';
import BooleanValue from '@components/booleanValue/BooleanValue';
import { VerifyButton } from '@routes/adminRoutes/sharedComponents/SharedStyledComponents';
import { adminVerifyEmail } from '@utils/api';
import { useToast } from '@contexts/Toast.context';
import { useConfirm } from '@contexts/Confirm.context';

const EmailVerify = ({ cellValue, email }) => {
	const { addToast } = useToast();
	const { confirm } = useConfirm();
	const [verified, setVerified] = useState(cellValue);

	const handleVerify = async () => {
		const userConfirmed = await confirm({
			title: 'Verify Email',
			message: (
				<>
					Are you sure you want to verify <strong>{email}</strong>?
				</>
			),
		});

		if (userConfirmed) {
			try {
				const response = await adminVerifyEmail(email);
				if (response?.status === 'success') {
					setVerified(true);
					addToast({
						id: 'email-verify-success',
						bg: 'success',
						title: 'Email verification is successful.',
					});
				} else {
					addToast({
						id: 'email-verify-error',
						bg: 'danger',
						title: 'Failed to verify email.',
					});
				}
			} catch (err) {
				console.error('Failed to verify email', err);
				addToast({
					id: 'email-verify-error',
					bg: 'danger',
					title: 'Failed to verify email.',
				});
			}
		}
	};

	return (
		<>
			<BooleanValue value={verified} />

			{!verified && (
				<VerifyButton size="sm" onClick={handleVerify}>
					Verify
				</VerifyButton>
			)}
		</>
	);
};

export default EmailVerify;
